module.exports = __webpack_public_path__ + "img/tesla-turret.9f12f7b6.svg";